<ap-edit-userprofile></ap-edit-userprofile>

<!--<ap-section-header>
  <ap-section-header-grid
    [iconId]="'ap-icon-settings'"
    [caption]="'Global_User_Profile' | translate"
    [filterPlaceholder]="'Global_Filter' | translate"
    [filterTooltip]="'Global_User_Profile' | translate"
    [showCanCreateButton]="false"
    [canCreate]="false"
    [canSearch]="false"
  ></ap-section-header-grid>
</ap-section-header>
<div class="ap-tabstrip-small">
  <kendo-tabstrip (tabSelect)="selectTab($event)" id="userTabStrip">
    <kendo-tabstrip-tab [selected]="true">
      <ng-template kendoTabTitle>
        <ap-responsive-text key="Profil" class="ap-tabstrip-header"></ap-responsive-text>
      </ng-template>
      <ng-template kendoTabContent>
        <ap-edit-userprofile></ap-edit-userprofile>
      </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab>
      <ng-template kendoTabTitle>
        <ap-responsive-text key="Einstellungen" class="ap-tabstrip-header"></ap-responsive-text>
      </ng-template>
      <ng-template kendoTabContent>
        <ap-user-settings></ap-user-settings>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
</div>
-->
